var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashflowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6667 4.99996H24.7C24 3.06663 22.1667 1.66663 20 1.66663C17.8333 1.66663 16 3.06663 15.3 4.99996H8.33333C6.5 4.99996 5 6.49996 5 8.33329V31.6666C5 32.5507 5.35119 33.3985 5.97631 34.0237C6.60143 34.6488 7.44928 35 8.33333 35H31.6667C33.5167 35 35 33.5166 35 31.6666V8.33329C35 7.44924 34.6488 6.60139 34.0237 5.97627C33.3986 5.35115 32.5507 4.99996 31.6667 4.99996ZM20 4.99996C20.9167 4.99996 21.6667 5.74996 21.6667 6.66663C21.6667 7.58329 20.9167 8.33329 20 8.33329C19.0833 8.33329 18.3333 7.58329 18.3333 6.66663C18.3333 5.74996 19.0833 4.99996 20 4.99996ZM11.6667 11.6666H28.3333V8.33329H31.6667V31.6666H8.33333V8.33329H11.6667V11.6666ZM16.6667 26.6666H13.3333V18.3333H10L15 13.3333L20 18.3333H16.6667V26.6666ZM23.3333 16.6666H26.6667V25H30L25 30L20 25H23.3333V16.6666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashflowWhite);
export default __webpack_public_path__ + "static/media/cashflow-white.1a1c69a4b97c2ec2796acba338266d42.svg";
export { ForwardRef as ReactComponent };